/**
 * Modulo que permite transformar fechas `new Date` para tomar en cuenta el timezone.
 */

/**
 * # Documentación
 * https://date-fns.org/v2.23.0/docs/Time-Zones
 * https://www.npmjs.com/package/date-fns-tz
 *
 * En verano, Si en Greenwich son las 13h00:
 * - En Madrid son las 15h00 (+2)
 * - En Mexico son las 8h00  (-5)
 * - En Tokyo son las 22h00 (+9)
 *
 * En ivierno, Si en Greenwich son las 13h00:
 * - En Madrid son las 14h00 (+1)
 * - En Mexico son las 7h00  (-6)
 * - En Tokyo son las 22h00 (+9)
 */

import { zonedTimeToUtc } from 'date-fns-tz';
import { onBeforeFormat } from './src/onBeforeFormat';

/**
 * Devuelve la fecha UTC quitando el timezone.
 *
 * > Nota: hace lo contrario de tz.parse
 *
 * @param {Object} state
 * @param {string|number|Date} value la fecha localizada del timezone `edicom.timezone` (no del timezone del navegador)
 * @returns {Date}
 *
 * @throws {TypeError} Invalid date
 */
export function utc(state, value) {
  const currentDate = onBeforeFormat(value);
  return zonedTimeToUtc(currentDate, state.timezone);
}
